import { trackEvent } from '@/lib/analytics'
import apiClient from '@/lib/api-client'
import type {
  JobSearch,
  JobSearchCreateRequest,
  JobSearchListResponse,
  JobSearchWithMatches,
} from '@/types'

export const jobSearchesService = {
  async create(payload: JobSearchCreateRequest): Promise<JobSearch> {
    const response = await apiClient.post<JobSearch>('/api/v1/job-searches', payload)
    trackEvent('match_set_created', {
      source_type: 'custom_search',
      has_job_ids: Boolean(payload.job_ids?.length),
    })
    return response.data
  },

  async list(skip = 0, limit = 20): Promise<JobSearchListResponse> {
    const response = await apiClient.get<JobSearchListResponse>('/api/v1/job-searches', {
      params: { skip, limit },
    })
    return response.data
  },

  async get(searchId: number, skip = 0, limit = 100): Promise<JobSearchWithMatches> {
    const response = await apiClient.get<JobSearchWithMatches>(`/api/v1/job-searches/${searchId}`, {
      params: { skip, limit },
    })
    return response.data
  },

  async delete(searchId: number): Promise<void> {
    await apiClient.delete(`/api/v1/job-searches/${searchId}`)
  },
}
